export function slugify(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function uniqueWithPrefix(name: string, prefix: string, existing: Set<string>): string {
  const slug = slugify(name) || 'unnamed'
  const base = `${prefix}-${slug}`
  if (!existing.has(base)) {
    existing.add(base)
    return base
  }
  let n = 2
  while (existing.has(`${base}-${n}`)) n++
  const id = `${base}-${n}`
  existing.add(id)
  return id
}

/** Returns a unique `measure-…` slug. Mutates `existing` by adding the new id. */
export function slugifyMeasureId(name: string, existing: Set<string>): string {
  return uniqueWithPrefix(name, 'measure', existing)
}

/** Returns a unique `initiative-…` slug. Mutates `existing` by adding the new id. */
export function slugifyInitiativeId(name: string, existing: Set<string>): string {
  return uniqueWithPrefix(name, 'initiative', existing)
}
